import React from 'react';
import Header from "../components/Header";
import TextBox from '../components/TextBox/TextBox';
import Photo from '../assets/estradas_noite.png';
import { Box, Typography} from '@mui/material';
import { createGlobalStyle } from 'styled-components';
import Footer from '../components/Footer';

const GlobalStyle = createGlobalStyle`
  body, html {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    overflow-x: hidden;
  }
`;
function About() {
  return (
    <div
      style={{
        backgroundColor: '#f0f0f0',
        margin: 0,
        padding: 0,
        minHeight: '100vh',
        position: 'relative',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      <GlobalStyle />
      <Header />

      {/* Box com imagem de fundo, overlay escura, logo e textos */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '200px',
          backgroundImage: `url(${Photo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Overlay escura */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '80%',
            backgroundColor: 'rgba(0, 0, 0, 0.87)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px',
          }}
        >
          

          {/* Título e subtítulo centralizados */}
          <Box
            sx={{
              textAlign: 'center',
              color: '#F2C12E',
              maxWidth: '600px',
              paddingLeft: { xs: '10px', sm: '0' },
              margin: '0 auto',
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontWeight: 'bold',
                fontSize: { xs: '1.5rem', sm: '3rem' },
              }}
            >
              Sobre Nós
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: '0.8rem', sm: '1.5rem' },
              }}
            >
              Descubra mais sobre nós
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Conteúdo abaixo da imagem */}
      <Box
        sx={{
          mt: 4,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          gap: 4,
        }}
      >
        <TextBox
          color="#ffffff"
          width={{ xs: '100%', sm: '400px' }}
          height="auto"
          title="Argos, o protetor perfeito"
          titleColor="#F2C12E"
          text="A mitologia grega é repleta de histórias fascinantes sobre deuses, monstros e heróis, e uma figura que se destaca é Argos Panoptes, o gigante de cem olhos. Reconhecido como o vigilante supremo, Argos era o guardião perfeito, sempre alerta e que nunca dormia por completo. Sua vigilância incansável tornava-o no protetor ideal, capaz de salvaguardar tesouros e conquistas."
          textColor="#666666"
        />

        <TextBox
          color="#ffffff"
          width={{ xs: '100%', sm: '400px' }}
          height="auto"
          title="Nosso legado"
          titleColor="#F2C12E"
          text="Na Argus Consultoria de Seguros, nos inspiramos nesse legado de proteção. Assim como Argos Panoptes, que mantinha um olhar atento sobre tudo, nós também temos o compromisso de zelar pela segurança e tranquilidade de nossos clientes. Sabemos que, em um mundo repleto de incertezas, a proteção das conquistas pessoais e familiares é essencial para que todos possam prosperar."
          textColor="grey"
        />

        <TextBox
          color="#ffffff"
          width={{ xs: '100%', sm: '400px' }}
          height="auto"
          title="Nosso Objetivo"
          titleColor="#F2C12E"
          text="Nosso objetivo é claro: proteger o que é mais importante para você - seus bens, sua família e suas realizações. E com a mesma dedicação e vigilância que caracterizavam Argos, estamos aqui para oferecer a segurança que você merece."
          textColor="grey"
        />
      </Box>

      {/* Box branca com título Nossos Valores */}
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#ffffff',
          padding: '20px 0',
          display: 'flex',
          justifyContent: 'center',
          margin: "20px 0px"
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 'bold',
            fontSize: "2.5rem",
            color: '#F2C12E',
            textAlign: 'center',
          }}
        >
          Nossos valores
        </Typography>
      </Box>

      {/* Conteúdo dos valores */}
      <Box
        sx={{
          mt: 4,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          gap: 4,
        }}
      >
        <TextBox
          color="#F2C12E"
          width={{ xs: '100%', sm: '400px' }}
          height="auto"
          title="Transparência"
          titleColor="#ffffff"
        />

        <TextBox
          color="#F2C12E"
          width={{ xs: '100%', sm: '400px' }}
          height="auto"
          title="Qualidade"
          titleColor="#ffffff"
        />

        <TextBox
          color="#F2C12E"
          width={{ xs: '100%', sm: '400px' }}
          height="auto"
          title="Agilidade"
          titleColor="#ffffff"
        />
      </Box>

      <Box sx={{ mt: 4 }}>
        <Footer/>
      </Box>
    </div>
  );
}

export default About;

